import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Component_HealthcareSpace.scss';
import { ComponentSync, LL_V_L, ModuleFE_AppConfig, TS_ErrorBoundary } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_Workspace, TS_HorizontalWorkspace, TS_Workspace } from '@nu-art/ts-workspace-frontend/index';
import { Panel_Values } from '../../values/Panel_Values.js';
import { Panel_Variables } from '../../variables/Panels/Panel_Variables.js';
import { Component_SubHeader } from '../../../shared-components/Component_SubHeader/Component_SubHeader.js';
import { WarningDialog } from '../../../shared-dialogs/WarningDialog/WarningDialog.js';
import { Panel_Tags } from '../../tags/Panel_Tags.js';
import { RoutePermissions } from '@nu-art/permissions-frontend/index';
import { ModuleFE_HCSPermissions } from '../../../../permissions/index.js';
import { ModuleFE_Tag } from '../../../../_entity/tag/ModuleFE_Tag.js';
import { ModuleFE_Variable } from '../../../../_entity/variable/ModuleFE_Variable.js';
import { ModuleFE_Expression } from '../../../../_entity/expression/ModuleFE_Expression.js';
import { ModuleFE_MacroTag } from '../../../../_entity/macro-tag/ModuleFE_MacroTag.js';
import { ModuleFE_Value } from '../../../../_entity/value/ModuleFE_Value.js';
const renderers = {
    horizontalSpace: TS_HorizontalWorkspace,
    categoriesPanel: Panel_Tags,
    variablesPanel: Panel_Variables,
    variableValuesPanel: Panel_Values,
};
const modulesToAwait = [
    ModuleFE_AppConfig,
    ModuleFE_Tag,
    ModuleFE_MacroTag,
    ModuleFE_Variable,
    ModuleFE_Value,
    ModuleFE_Expression
];
export class Component_HealthcareSpace extends ComponentSync {
    static Route = {
        key: 'healthcare-space',
        path: 'healthcare-space',
        Component: this,
        enabled: RoutePermissions(ModuleFE_HCSPermissions.permissions.ui.Release),
        modulesToAwait: modulesToAwait
    };
    workspaceKey = 'healthcare-space';
    render() {
        return (_jsx(TS_ErrorBoundary, { onClick: async (e) => {
                await ModuleFE_Workspace.deleteWorkspaceByKey(this.workspaceKey);
                this.forceUpdate();
            }, children: _jsxs(LL_V_L, { className: 'health-care-space', children: [_jsx(Component_SubHeader, { cleanWorkspace: () => {
                            WarningDialog.showDelete({
                                onConfirm: async () => {
                                    await ModuleFE_Workspace.deleteWorkspaceByKey(this.workspaceKey);
                                    location.reload();
                                },
                                warningMessages: ['Delete healthcare space workspace?'],
                                executeButtonText: 'Delete Workspace',
                            });
                        }, children: _jsx("div", { style: { flexGrow: 1 } }) }), _jsx(TS_Workspace, { workspaceKey: this.workspaceKey, renderers: renderers })] }) }));
    }
}
//# sourceMappingURL=Component_HealthcareSpace.js.map